import { LineItemNumericCalculatorField } from "components/formFields/LineItemNumericCalculatorField";
import { LineTableCell } from "components/formFields/LineTableCell";

import { LINE_ITEM_METADATA } from "editConfig";

export function LineReturned(props) {
  const { value, onValueChange, objectType, lineReadOnly } = props;

  return (
    <LineTableCell sx={{ minWidth: "6rem" }}>
      <LineItemNumericCalculatorField
        name="returned"
        value={value}
        onValueChange={onValueChange}
        metadata={LINE_ITEM_METADATA[objectType].returned}
        lineReadOnly={lineReadOnly}
      />
    </LineTableCell>
  );
}
